import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import { useApiClient } from '../../lib/api';
import BillingStatusBadge from './BillingStatusBadge';
import { formatDate, formatMoney } from '../../utils/billingUtils';

const MESSAGE_BY_STATUS = {
  pending_payment: 'A assinatura está aguardando regularização para manter a operação estável.',
  past_due: 'A assinatura está em atraso. Regularize a cobrança para evitar bloqueio do acesso e do QR público.'
};

export default function BillingStatusBanner({ role }) {
  const api = useApiClient();
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    let isMounted = true;

    if (role === 'AdminMaster') {
      return undefined;
    }

    const load = async () => {
      try {
        const response = await api.get('/api/v1/billing/current');
        if (!isMounted) {
          return;
        }
        setSubscription(response.data || null);
      } catch {
        if (isMounted) {
          setSubscription(null);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [api, role]);

  if (!subscription || !MESSAGE_BY_STATUS[subscription.status]) {
    return null;
  }

  return (
    <section className="mb-6 rounded-2xl border border-amber-200 bg-amber-50 p-4 shadow-sm">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div className="flex gap-3">
          <div className="rounded-2xl bg-amber-100 p-2 text-amber-700">
            <ExclamationTriangleIcon className="h-5 w-5" />
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <h2 className="text-sm font-semibold text-amber-900">Situação da assinatura</h2>
              <BillingStatusBadge status={subscription.status} />
            </div>
            <p className="mt-2 text-sm text-amber-900">{MESSAGE_BY_STATUS[subscription.status]}</p>
            <p className="mt-2 text-xs text-amber-800">
              Plano {subscription.planName} · {formatMoney(subscription.priceAmount, subscription.currency)} · próximo vencimento em {formatDate(subscription.nextDueAt)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
